"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toyota = exports.Lexus = void 0;
var _styledComponents = require("styled-components");
var _LexusTypography = require("../LexusTypography");
var _ToyotaTypography = require("../ToyotaTypography");
var _breakpoints = _interopRequireDefault(require("../breakpoints"));
var Styled = _interopRequireWildcard(require("./index.styled"));
const Lexus = exports.Lexus = (0, _styledComponents.css)`
  ${Styled.TileGrid} {
    margin-bottom: 80px;
  }

  ${Styled.TileContainer} {
    gap: 10px;
  }

  ${Styled.VLPTileContainer} {
    gap: 10px;
  }

  ${Styled.Heading} {
    ${(0, _LexusTypography.nobel)({
  weight: "regular",
  sizing: "subheading18",
  spacing: "narrow"
})}
    margin-bottom: 30px;
    &.hasDisclaimer {
      margin-bottom: 19px;
    }
  }

  ${Styled.Disclaimer} {
    ${(0, _LexusTypography.nobel)({
  weight: "book",
  sizing: "legal10",
  spacing: "narrow"
})}
  }
`;
const Toyota = exports.Toyota = (0, _styledComponents.css)`
  ${Styled.TileContainer} {
    gap: 20px;
  }

  ${Styled.VLPTileContainer} {
    gap: 24px 48px;
  }

  ${Styled.Heading} {
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "heading04",
  spacing: "0"
})}
    margin-bottom: 32px;
    &.hasDisclaimer {
      margin-bottom: 24px;
    }
    ${(0, _breakpoints.default)("tablet", "up")} {
      ${(0, _ToyotaTypography.ToyotaType)({
  weight: "semibold",
  sizing: "heading03",
  spacing: "0"
})}
    }
  }
  ${Styled.Disclaimer} {
    ${(0, _ToyotaTypography.ToyotaType)({
  weight: "regular",
  sizing: "legal01",
  spacing: "0"
})}
  }
`;